import { useTranslation } from 'react-i18next';

import colorsStore from 'shared/store/colorsStore';
import chatStore from 'shared/store/chatStore';
import { AttachmentsIcon } from 'shared/assets/svg/menu-icons/AttachmentsIcon';
import { AttachmentItem } from './AttachmentItem';
import { ScrollArea } from 'shared/components/ui/scroll-area';
import styles from '../AttachmentsPanel.module.scss';

export const AttachmentsPanelContent: React.FC = () => {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);
  const { t } = useTranslation();
  const { files } = chatStore();

  if (!files || files.length === 0) {
    return (
      <div className={styles.attachmentsPanelContentEmpty}>
        <div className={styles.attachmentsPanelContentIcon}>
          <AttachmentsIcon size={48} color={colorsConfig.chatCopyColor} />
        </div>
        <h3 className={styles.attachmentsPanelContentTitle}>{t('attachment.noAttachments')}</h3>
        <p className={styles.attachmentsPanelContentDescription}>{t('attachment.noAttachmentsDescription')}</p>
      </div>
    );
  }

  return (
    <ScrollArea className={styles.attachmentsPanelContentList}>
      <div className={styles.attachmentsPanelContentListItems}>
        {files.map((file) => (
          <AttachmentItem key={file.id} file={file} />
        ))}
      </div>
    </ScrollArea>
  );
};
